import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=cbb65f10&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=cbb65f10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb65f10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Plus: require('/vercel/path0/components/icons/Plus.vue').default})
